'use strict';
export const Constants = Object.freeze({
  MC_SURVEY_TABLE_HEADERS: {
    SURVEY_STATUS: {
      label: 'Status',
      orderKey: 'ps_survey_status',
    },
    SURVEY_ID: {
      label: 'Survey ID',
      orderKey: 'ps_survey_id',
    },
    MULTI_COUNTRY: {
      label: 'Multicountry',
      orderKey: 'country_name',
    },
    CURRENT_CPI: {
      label: 'Current CPI',
      orderKey: 'cpi_current',
    },
    AVERAGE_CPI: {
      label: 'Avg. CPI',
      orderKey: 'avg_cpi',
    },
    EPC: {
      label: 'EPC',
      orderKey: 'epc',
    },
    CURRENT_IR: {
      label: 'Current IR',
      orderKey: 'current_ir',
    },
    FIELDED_DETAILS: {
      label: 'Fielded Vs Goal',
      orderKey: 'fielded',
    },
    SURVEY_COMPLETES: {
      label: 'Complete',
      orderKey: 'completes_required',
    },
    SURVEY_COUNTRY_PROGRESS: {
      label: 'Country Progress',
      orderKey: 'country_progress',
    },
    IN_PROGRESS: {
      label: 'In Progress',
      orderKey: 'in_progress',
    },
  },

  SUPPLIER_SUB_TABLE_HEADERS: [
    {
      label: 'Supplier Name',
      orderKey: 'name',
    },
    {
      label: 'Fielded Vs Goal',
      orderKey: 'fielded_vs_goal',
    },
    {
      label: 'Supplier Currently Open',
      orderKey: 'supplier_currently_open',
    },
    {
      label: 'Valid Clicks',
      orderKey: 'valid_clicks',
    },
    {
      label: 'Last Start Date',
      orderKey: 'last_start_date',
    },
    {
      label: 'Last Complete Date',
      orderKey: 'last_complete_date',
    },
    {
      label: 'Conversion',
      orderKey: 'conversion_rate',
    },
    {
      label: 'In Progress',
      orderKey: 'buyer_in_progress',
    },
  ],

  CHILD_CREATION_STATUS: {
    PENDING: 0,
    READY: 1,
    ERROR: 2,
  },
});
